import { useLogoSrc } from './useLogoSrc';

/** The mark alone, for the collapsed sidebar. */
export const LogoIcon = () => {
  const src = useLogoSrc();
  return <img src={src} style={{ height: 36, width: 36 }} alt="" />;
};
